@use 'ui/styles/core-tokens' as core;

.layout {
  display: flex;
  flex-basis: 100%;
  height: 100vh;
  overflow-y: hidden;
  width: 100%;

  &Sidebar {
    display: flex;
    flex-shrink: 0;

    > div {
      -ms-overflow-style: none;
      overflow-y: scroll;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  &Main {
    display: flex;
    flex-basis: 100%;
    flex-direction: column;
    min-width: 824px;
    overflow-y: auto;
  }

  &Container {
    flex: 1 1 0;
    padding: core.$layout-padding;
  }
}
